var _g, _rect, _rect2, _rect3, _g2, _g3, _rect4, _rect5, _rect6, _g4, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermissionsLoadingMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 82,
    viewBox: "0 0 300 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11751_15990)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 280,
    height: 24,
    rx: 2,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 17.168,
    width: 13.7054,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.8682,
    y: 17.168,
    width: 166,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 207.031,
    y: 17.168,
    width: 48,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11751_15990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.667 14H276.333C276.51 14 276.68 14.0702 276.805 14.1953C276.93 14.3203 277 14.4899 277 14.6667V25.3333C277 25.5101 276.93 25.6797 276.805 25.8047C276.68 25.9298 276.51 26 276.333 26H265.667C265.49 26 265.32 25.9298 265.195 25.8047C265.07 25.6797 265 25.5101 265 25.3333V14.6667C265 14.4899 265.07 14.3203 265.195 14.1953C265.32 14.0702 265.49 14 265.667 14ZM270.335 22.6667L275.049 17.9527L274.106 17.01L270.335 20.7813L268.449 18.8953L267.507 19.838L270.335 22.6667Z",
    fill: "#121B2E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11751_15990)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 44,
    width: 280,
    height: 24,
    rx: 2,
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 53.168,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95.1628,
    y: 53.168,
    width: 32,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130.326,
    y: 53.168,
    width: 125,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11751_15990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.667 50H276.333C276.51 50 276.68 50.0702 276.805 50.1953C276.93 50.3203 277 50.4899 277 50.6667V61.3333C277 61.5101 276.93 61.6797 276.805 61.8047C276.68 61.9298 276.51 62 276.333 62H265.667C265.49 62 265.32 61.9298 265.195 61.8047C265.07 61.6797 265 61.5101 265 61.3333V50.6667C265 50.4899 265.07 50.3203 265.195 50.1953C265.32 50.0702 265.49 50 265.667 50ZM270.335 58.6667L275.049 53.9527L274.106 53.01L270.335 56.7813L268.449 54.8953L267.507 55.838L270.335 58.6667Z",
    fill: "#121B2E"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 10,
    fill: "#121B2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6571 5.4407V14.168H12.0762V6.97905H12.025L9.98384 8.28303V6.83416L12.1529 5.4407H13.6571Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11751_15990",
    x: 0,
    y: 2,
    width: 300,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11751_15990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11751_15990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11751_15990",
    x: 0,
    y: 38,
    width: 300,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11751_15990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11751_15990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11751_15990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(263 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11751_15990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(263 48)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionsLoadingMobile);
export default __webpack_public_path__ + "static/media/permissions_loading_mobile.f75badadeb7ef04db71e23675b84b4f9.svg";
export { ForwardRef as ReactComponent };